import { createSelector } from 'reselect';
import { Invoice } from './invoice';
import { GET_INVOICES_SUCCESS, InvoicesAction } from './invoices.action';

export interface InvoiceState {
  list: {
    data: Invoice[];
    total: number;
  };
}

export const initialState: InvoiceState = {
  list: {
    data: [],
    total: 0
  }
};

export function invoicesReducer(state: InvoiceState = initialState, action: InvoicesAction): InvoiceState {
  switch (action.type) {
    case GET_INVOICES_SUCCESS:
      const data = action.payload;
      return {
        ...state,
        list: {
          data: data,
          total: data.length
        }
      };
    default: {
      return state;
    }
  }
}

export const getList = (state: InvoiceState) => state.list.data;
export const getListTotal = (state: InvoiceState) => state.list.total;

export const getMainInvoiceSelector = (state): InvoiceState => state.billing.invoices;
export const getInvoicesListSelector = createSelector(getMainInvoiceSelector, getList);
export const getInvoicesTotalSelector = createSelector(getMainInvoiceSelector, getListTotal);
